var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "108px",
    height: "97px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.962
    },
    fill: "#ffe900",
    d: "M 43.5,44.5 C 42.7109,44.7828 42.0442,45.2828 41.5,46C 53.4954,46.4999 65.4954,46.6665 77.5,46.5C 81.5,48.8333 81.5,51.1667 77.5,53.5C 65.4954,53.3335 53.4954,53.5001 41.5,54C 42.0442,54.7172 42.7109,55.2172 43.5,55.5C 46.8237,58.3235 49.9904,61.3235 53,64.5C 53.692,67.7707 52.3587,69.7707 49,70.5C 40.3349,64.9221 32.8349,58.0888 26.5,50C 32.8349,41.9112 40.3349,35.0779 49,29.5C 52.3587,30.2293 53.692,32.2293 53,35.5C 49.9904,38.6765 46.8237,41.6765 43.5,44.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.247
    },
    fill: "#ffe600",
    d: "M 43.5,44.5 C 54.8333,45.1667 66.1667,45.8333 77.5,46.5C 65.4954,46.6665 53.4954,46.4999 41.5,46C 42.0442,45.2828 42.7109,44.7828 43.5,44.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.251
    },
    fill: "#ffe600",
    d: "M 77.5,53.5 C 66.1667,54.1667 54.8333,54.8333 43.5,55.5C 42.7109,55.2172 42.0442,54.7172 41.5,54C 53.4954,53.5001 65.4954,53.3335 77.5,53.5 Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBack);
export default __webpack_public_path__ + "static/media/iconBack.8c7445dd13f5820094ba18189e0db24c.svg";
export { ForwardRef as ReactComponent };